import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserConfigDto } from 'src/providersdata/UserConfigDto';
import { UserRoot } from './UsuarioLogado';
import { ModalTemplatePage } from '../../app/config/modals/modal-template/modal-template.page';
import { APIService } from './apiservices';
import { ToastColors } from './globalservices';


@Injectable()
/**
 *      <ion-select-option [value]=1>Inicio</ion-select-option>
*      <ion-select-option [value]=2>Informe de vendas - Informar Vendas</ion-select-option>
*        <ion-select-option [value]=3>Informe de vendas - Alterar Vendas</ion-select-option>
*        <ion-select-option [value]=4>Financeiro - Visualizar Boleto</ion-select-option>
*        <ion-select-option [value]=5>Financeiro - Visualizar Prestação de Contas</ion-select-option>
*        <ion-select-option [value]=6>Biblioteca</ion-select-option>
*        <ion-select-option [value]=7>Autorizacao</ion-select-option>
*        <ion-select-option [value]=8>Conheça seus Clientes</ion-select-option>
*        <ion-select-option [value]=9>Formulário Benefício</ion-select-option>
 */
   

export class ShowModalService {
    
    public static modais=[];
    public static controledisparo=[];

    public static show (disparo,login, tipoUsuario,modalCtrl,localstorage, globalService, mensagem)
    {
        // verificar se o disparo
        if (this.modais?.length>0){
            if (tipoUsuario>1){
                localstorage
                .get(`${APIService.storage_key}${login}_modais`)
                .then((val) => {
                    var disparar=false;
                    var modal;

                    if (val != null) {
                        this.controledisparo=val;
                        
                    } 
                    else{
                       this.controledisparo=[]; 
                    }
                    const hoje = new Date();
                                    
                    this.modais.forEach(element => {
                        
                        if (element.disparo==disparo)
                        {
                            var data={
                                guid:element.guid,
                                numdisparo:0,
                                diadisparo:hoje
                            }
                            disparar=true;
                            modal=element;
                            var var1 = this.controledisparo.find(p => p.guid ===element.guid);
                            if (var1){
                                data.numdisparo=var1.numdisparo;
                                if (element.repetir==1){
                                    // if (var1.numdisparo==1){
                                    //     disparar=false;
                                    // }
                                    const dataAtual = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
                                    const dataComparar = new Date(var1.diadisparo.getFullYear(), var1.diadisparo.getMonth(), var1.diadisparo.getDate());
                                    const diffDias = (dataAtual.getTime() - dataComparar.getTime()) / (1000 * 60 * 60 * 24);
                                        
                                    // pegar a data do dia
                                    if (element.frequencia==1)
                                    {
                                        // todos os dias
                                        const ehDiaSeguinteOuMaior = diffDias >= 1;
                                        if (ehDiaSeguinteOuMaior==false){
                                            disparar=false;

                                        }
                                        //console.log('Dia seguinte ou maior?', ehDiaSeguinteOuMaior);

                                    }
                                    else if (element.frequencia==2){
                                        // 1 x por semana
                                        const diffSemanas = diffDias / 7;
                                        const ehSemanaSeguinteOuMaior = diffSemanas >= 1;
                                        //console.log('Semana seguinte ou maior?', ehSemanaSeguinteOuMaior);
                                        if (ehSemanaSeguinteOuMaior==false){
                                            disparar=false;
                                        }

                                    }
                                    else if (element.frequencia==3){
                                        // 1 x por mes
                                        const diffMeses =
                                            (dataAtual.getFullYear() - dataComparar.getFullYear()) * 12 +
                                            (dataAtual.getMonth() - dataComparar.getMonth());
                                        const ehMesSeguinteOuMaior = diffMeses >= 1;
                                        //console.log('Mês seguinte ou maior?', ehMesSeguinteOuMaior);
                                        if (ehMesSeguinteOuMaior==false){
                                            disparar=false;
                                        }


                                    }
                                }
                                else{
                                    data.numdisparo++;
                                }

                            }
                            else{
                                data.numdisparo++;
                            }

                            if (disparar){
                                if (this.controledisparo.length==0){
                                    this.controledisparo.push(data);
                                }
                                else{
                                    const index = this.controledisparo.findIndex(u => u.guid === element.guid);
                                    if (index !== -1) {
                                        this.controledisparo[index] = data;
                                    }
                                    else{
                                        this.controledisparo.push(data);
                                    }
                                }

                            }
                            
                        }
                    });

                    if (disparar){
                        localstorage
                        .set(
                        `${APIService.storage_key}${login}_modais`,
                        this.controledisparo
                        )
                        .then(() => {
                            // abre o modal
                            if (disparar){
                                this.openPreviewModal(modal,mensagem,modalCtrl);
                            }

                        });

                    }
                    else{
                        if (globalService){
                            globalService.presentToast(mensagem, ToastColors.success);
                        }
                    }
                                    
                });
               
                
                
            }
            else{
                if (globalService){
                    globalService.presentToast(mensagem, ToastColors.success);
                }
            }

            
        }
        else{
            if (globalService){
                globalService.presentToast(mensagem, ToastColors.success);

            }
        }
        
    }

    private static async openPreviewModal(item,mensagem,modalCtrl) {
        /*
        let modalClass = 'modal-responsivo';
        if(hasToast==true){
        modalClass = 'modal-responsivo-toast';
        }

        const modal = await this.modalCtrl.create({
        component: ModalTemplatePage,
        cssClass: modalClass,
        componentProps: {
            item
        },
        backdropDismiss: false
        });
        */
       let modalClass = 'modal-responsivo';
        if(mensagem){
            modalClass = 'modal-responsivo-toast';
        }



        const modal = await modalCtrl.create({
          component: ModalTemplatePage,
          cssClass: modalClass,
          componentProps: {
            item,
            mensagem,
            acaousuario:true
          },
          backdropDismiss: false
        });
    
        await modal.present();
    }


 

}
